import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, Mail, Loader, User, Shield } from 'lucide-react';

// Note: Firebase imports - uncomment in your project
import { checkActionCode, applyActionCode, getAuth } from 'firebase/auth';
import { auth } from './Auth';

import './EmailVerification.css';

const EmailVerification = () => {
  const [verificationStatus, setVerificationStatus] = useState('loading'); // loading, success, error
  const [errorMessage, setErrorMessage] = useState('');
  const [actionCode, setActionCode] = useState('');
  const [userInfo, setUserInfo] = useState(null);
  const [isUpdatingBackend, setIsUpdatingBackend] = useState(false);

  useEffect(() => {
    // Get the action code from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const mode = urlParams.get('mode');
    const oobCode = urlParams.get('oobCode');
    const continueUrl = urlParams.get('continueUrl');

    console.log('URL parameters:', { mode, oobCode, continueUrl });

    if (mode === 'verifyEmail' && oobCode) {
      setActionCode(oobCode);
      verifyEmail(oobCode);
    } else {
      setVerificationStatus('error');
      setErrorMessage('Invalid verification link. Please check your email for the correct link.');
    }
  }, []);

  const verifyEmail = async (code) => {
    try {
      console.log('Starting email verification process...');
      const info = await checkActionCode(auth, code);
      const email = info.data.email;

      await applyActionCode(auth, code);
      const response = await fetch('https://api-toymz7ykda-uc.a.run.app/verify', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      console.log(response)  
      setVerificationStatus('success');
      
    } catch (error) {
      console.error('Email verification error:', error);
      setVerificationStatus('error');
      
      // Handle specific Firebase errors
      switch (error.code) {
        case 'auth/expired-action-code':
          setErrorMessage('This verification link has expired. Please request a new one.');
          break;
        case 'auth/invalid-action-code':
          setErrorMessage('This verification link is invalid. Please check your email for the correct link.');
          break;
        case 'auth/user-disabled':
          setErrorMessage('This account has been disabled.');
          break;
        case 'auth/user-not-found':
          setErrorMessage('No user found for this verification link.');
          break;
        default:
          setErrorMessage('An error occurred while verifying your email. Please try again.');
      }
    }
  };

  return (
    <div className="verification-container">
      <div className="verification-card">
        {/* Logo */}
        <div className="verification-logo">
          our<span className="verification-logo-bold">vibe</span>
        </div>

        {/* Loading State */}
        {verificationStatus === 'loading' && (
          <div>
            <div className="verification-icon-container">
              <Loader className="verification-icon-loading" />
            </div>
            <h1 className="verification-title">
              Verifying Your Email
              <span className="loading-dots">
                <span className="loading-dot"></span>
                <span className="loading-dot"></span>
                <span className="loading-dot"></span>
              </span>
            </h1>
            <p className="verification-description">
              Please wait while we verify your email address and set up your account.
            </p>
            {isUpdatingBackend && (
              <p style={{ color: '#9ca3af', fontSize: '0.875rem', marginTop: '1rem' }}>
                Updating your profile...
              </p>
            )}
          </div>
        )}

        {/* Success State */}
        {verificationStatus === 'success' && (
          <div>
            <div className="verification-icon-container">
              <CheckCircle className="verification-icon-success" />
            </div>
            <h1 className="verification-title verification-title-success">
              Email Verified Successfully!
            </h1>
            <p className="verification-description">
              Your email has been verified and your account is now active. Welcome to Our Vibe!
            </p>
          </div>
        )}

        {/* Error State */}
        {verificationStatus === 'error' && (
          <div>
            <div className="verification-icon-container">
              <XCircle className="verification-icon-error" />
            </div>
            <h1 className="verification-title verification-title-error">
              Verification Failed
            </h1>
            <p className="verification-description">
              {errorMessage || 'We couldn\'t verify your email address. Please try again.'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;